
<template>
  <div>
    <div id="addToMap">
      <div id="addToMapButton" v-bind:class="{ active: addToMapMenu }" @click="toggle()">
        <svgicon icon="plus" width="48" height="48" color="#fff"></svgicon>
      </div>
      <div id="addToMapMenu" v-if="addToMapMenu">
        <button class="btn--subtile"><svgicon icon="statistics" width="32" height="32" color="#000000"></svgicon> SAP Data</button>
        <button class="btn--subtile"><svgicon icon="persona" width="32" height="32" color="#000000"></svgicon> Persona</button>
        <button @click="createNew('area')" class="btn--subtile"><svgicon icon="area" width="32" height="32" color="#000000"></svgicon> Bereich</button>
        <!-- <button @click="createNew('link')" class="btn--subtile"><svgicon icon="link" width="32" height="32" color="#000000"></svgicon> Verknüpfung</button> -->
        <button @click="createNew('post')" class="btn--subtile"><svgicon icon="flag" width="32" height="32" color="#000000"></svgicon> Beitrag</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AddToMap',
  data () {
    return {
      addToMapMenu: false
    }
  },
  methods: {
    toggle () {
      if (this.addToMapMenu) {
        this.addToMapMenu = false
      } else {
        this.addToMapMenu = true
      }
    },
    createNew: function (type) {
      this.$emit('createNew', type)
      this.addToMapMenu = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

  #addToMap {
    position: absolute;
    bottom: 20px;
    left: 20px;
    z-index: 9999;
    color: #fff;

    #addToMapButton {
      cursor: pointer;
      position: absolute;
      bottom: 0;
      left: 0;
      border-radius: 50%;
      background: $color-action;
      height: 48px;
      width: 48px;
      z-index: 3;
      user-select:none;
      box-shadow: 0 2px 5px 0 rgba($color-text,0.3);
      transition: all 0.3s ease;

      &.active {
        transform: rotate(45deg);
      }

    }

    #addToMapMenu {
      background:#fff;
      z-index: 2;
      position: absolute;
      left: 24px;
      bottom: 24px;
      width: 220px;
      font-size: 17px;
      text-transform: uppercase;
      line-height: 48px;
      font-weight: 700;
      box-shadow: 0 2px 5px 0 rgba($color-text,0.3);
    }

    button {

      width: 100%;
      margin-left: 0;
      margin-bottom: 0;
      font-weight: 700;
      text-align: left;
      padding: 0px 20px !important;
      border-top: 1px solid rgba($color-grey,0.25);
      color: $color-text;

      svg path {
        color: $color-grey;
      }

    }

  }

</style>



// WEBPACK FOOTER //
// src/components/AddToMap.vue